import { render, staticRenderFns } from "./diet-tags.vue?vue&type=template&id=58838a40&"
import script from "./diet-tags.vue?vue&type=script&lang=js&"
export * from "./diet-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports